"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.tooltips.talk': 'Iniciar conversación con este avatar',
    'avatar.tooltips.preview': 'Vista previa de detalles del avatar',
    'avatar.tooltips.edit': 'Editar configuración del avatar',
    'avatar.tooltips.delete': 'Eliminar este avatar',
};
